import React from 'react'
import { BFormGroup, BLabel, BInput, BFormText } from '@prague-digi/ui-components'
import { Field, WrappedFieldProps } from 'redux-form'

import msg from '../../i18n'
import { intl, IntlInterface } from '../../hoc'

import styles from './styles.scss'

// The controlled value is a number, falling back to string whenever an invalid
// input is entered so that the user can continue editing; null value is supported
// to render an empty input.

interface Props {
  defaultValue?: number
  fullDecimals?: number
  maxValue?: number
  messages?: {
    label?: string
    notice?: string
  }
  minValue?: number
  name: string
  noMessage?: boolean
  onBlur?: any
  onChange?: (value: number) => void
  theme?: string
}

const SAFE_INT = 9007199254740991

export class MoneyInput extends React.Component<
  Props & WrappedFieldProps & IntlInterface,
  any,
  any
> {
  handleChange = (evt: any) => {
    const strVal = `${evt.target.value}`
    const trimmedVal = strVal.replace(/\s/g, '').replace(/,/g, '.')
    const numVal = Number(trimmedVal)
    const useNumeric = trimmedVal !== '' && !isNaN(numVal) && Math.abs(numVal) < SAFE_INT
    const outputVal = useNumeric ? numVal : evt.target.value
    this.props.input.onChange(outputVal)
    this.props.onChange && this.props.onChange(outputVal)
  }

  handleBlur = (evt: any) => {
    if (evt && /^(\s|\d)+$/.test(evt.target.value)) {
      const strVal = `${evt.target.value}`
      const trimmedVal = strVal.replace(/\s/g, '')

      let numVal = Number(trimmedVal)
      const useNumeric = trimmedVal !== '' && !isNaN(numVal) && Math.abs(numVal) < SAFE_INT
      if (!useNumeric) {
        numVal = this.props.defaultValue ? this.props.defaultValue : 0
      }
      if (this.props.fullDecimals) {
        numVal = Math.round(
          (numVal / 10 ** this.props.fullDecimals) * 10 ** this.props.fullDecimals
        )
      }

      if (this.props.minValue && numVal < this.props.minValue) {
        numVal = this.props.minValue
      }

      if (this.props.maxValue && numVal > this.props.maxValue) {
        numVal = this.props.maxValue
      }

      // eslint-disable-next-line no-param-reassign
      evt.target.value = numVal
    }
    this.props.input.onBlur(evt)
  }

  prepareValue = (): string => {
    const value = this.props.input.value
    if (value === null || value === undefined || value === '') {
      return ''
    }
    const numVal = Number(value)
    if (isNaN(numVal) || Math.abs(numVal) >= SAFE_INT) {
      return value
    }
    return this.props.intl.formatNumber(numVal)
  }

  render() {
    const { messages, meta, name, noMessage, theme } = this.props
    const label = messages?.label

    const notice = messages?.notice
    const warning = meta.touched && meta.warning
    const error = meta.touched && meta.error

    return (
      <BFormGroup error={!!error} warning={!!warning} theme={theme}>
        {label && <BLabel>{label}</BLabel>}
        <div className={styles.moneyContainer}>
          <BInput
            value={this.prepareValue()}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            theme={styles.moneyInput}
            name={name}
            testid={name}
          />
          <BFormText theme={styles.currency}>{this.props.translate(msg.common.CZK)}</BFormText>
        </div>
        {!noMessage && (notice || error || warning) && (
          <p>
            {notice && <BFormText>{notice}</BFormText>}
            {error && <BFormText>{error}</BFormText>}
            {warning && <BFormText>{warning}</BFormText>}
          </p>
        )}
      </BFormGroup>
    )
  }
}

export const renderMoneyInput = intl(MoneyInput)

// @ts-ignore
export const MoneyInputField = (props: Props) => <Field {...props} component={renderMoneyInput} />

export default MoneyInputField
